import { getStoryblokApi as _getStoryblokApi } from '@storyblok/react/rsc'

let storyblokApi: ReturnType<typeof _getStoryblokApi> | null = null

export function getStoryblokApi() {
  if (!storyblokApi) {
    storyblokApi = _getStoryblokApi()
  }
  return storyblokApi
}

export function initStoryblokApi() {
  if (!storyblokApi) {
    storyblokApi = _getStoryblokApi()
  }
}
